import React, {useContext, useEffect, useState} from 'react';
import {Dialog, DialogActions, Button, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import {Grid, Typography} from "@material-ui/core";
import {grey} from "@material-ui/core/colors";
import {makeStyles} from "@material-ui/core/styles";
import {PermissionsContext} from "../providers/Permissions";
import config from "../configs/config";
import api from "../services/api";
import Alert from "./Alert";


export default function Modal({open, handleView, notification_web}) {
    const classes = useStyles();

    const [userFaceUrl, setUserFaceUrl] = useState('');
    const [mediaUrl, setMediaUrl] = useState('');

    const [loadingMedia, setLoadingMedia] = useState();

    const [message, setMessage] = useState({
        open: false,
        variant: '',
        text: '',
    });

    const closeMessage = () => {
        setMessage({
            open: false,
            variant: '',
            text: '',
        });
    };

    const dhiAccess = ['UserAccessRecord'];
    const cameraAccess = ['FaceDetectionRecord', 'FaceRecognitionRecord'];

    const { host, port } = config;

    const {
        PermissionWrapper,
        PermissionOneOfWrapper,
        hasPermission,
    } = useContext(PermissionsContext);

    useEffect(() => {
        const handleOpenAccessDetails = async (access) => {
            if (dhiAccess.includes(access.type) && hasPermission("/relatorio_unificado/imagem/:id")) {
                await seeImage(access, false, false);
                if (access?.user?.face_image) setUserFaceUrl(`http://${host}:${port}/midias/imagem/face/${access.user.face_image}`);
            } else if (cameraAccess.includes(access.type) && hasPermission("/relatorio_unificado/video/:id")) {
                await watchVideo(access, false, false);
                if (access?.user?.face_image) setUserFaceUrl(`http://${host}:${port}/midias/imagem/face/${access.user.face_image}`);
            }

            console.log("o ip foi", notification_web?.web_notification?.access_log)
        }

        handleOpenAccessDetails(notification_web?.web_notification?.access_log)
    }, []);

    const seeImage = async (accessLog, useLoading = true, clearOnError = true) => {
        if (useLoading) setLoadingMedia(true);
        let loadedWithSuccess = false;

        try {
            const result = await api.get(`/access_log/image/${accessLog.id}`);

            const { image } = result.data;

            const imagePath = `http://${host}:${port}/midias/imagem/acesso/${image}`

            setMediaUrl(imagePath);
            loadedWithSuccess = true;
        } catch (err) {
            console.log(err);
            if (clearOnError) clearMedia();

            setMessage({
                open: true,
                variant: 'error',
                text: 'Não foi possível baixar a imagem do acesso',
            });
        }
        if (useLoading) setLoadingMedia(false);
        return loadedWithSuccess;
    }

    const clearMedia = () => {
        setMediaUrl('');
        setLoadingMedia(false);
    };

    const watchVideo = async (accessLog, useLoading = true, clearOnError = true) => {
        if (useLoading) setLoadingMedia(true);
        let loadedWithSuccess = false;

        try {
            const result = await api.get(`/access_log/video/${accessLog.id}`);

            const { video } = result.data;

            const videoPath = `http://${host}:${port}/midias/video/acesso/${video}`;

            setMediaUrl(videoPath);
            loadedWithSuccess = true;
        }
        catch (err) {
            console.log(err)
            if (clearOnError) clearMedia();

            setMessage({
                open: true,
                variant: 'error',
                text: 'Não foi possível baixar o vídeo do acesso',
            });
        }
        if (useLoading) setLoadingMedia(false);
        return loadedWithSuccess;
    };

    const AccessMedia = ({ log, url }) => {
        const classes = useStyles();

        if (log && dhiAccess.includes(log.type)) {
            return (
                <img src={url} className={classes.video} alt="IMAGEM" />
            );
        } else if (log && cameraAccess.includes(log.type)) {

            return (
                <video controls className={classes.video}>
                    <source src={url} />
                </video>
            );
        } else {
            return <></>
        }
    };

    return (
        <div>
            <Dialog
                open={open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                scroll='paper'
                fullWidth={true}
                maxWidth="lg"
            >
                <Grid container>
                    <Grid
                        item
                        xs={4}
                        style={{
                            background: grey[300],
                            height: "900px",
                            padding: 6
                        }}
                        onClick={() => console.log(`o access log ${notification_web?.web_notification?.access_log}`)}
                    >
                        <Grid container alignItems='center' justify='center' style={{gap: 6, height: '100%'}}>
                            <Grid container alignItems='center' justify='center'>
                                <Typography
                                    variant="subtitle1"
                                    className={classes.accessImageAlt}
                                >
                                    NO CADASTRO
                                </Typography>
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        background: grey[500],
                                        height: "300px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: 15
                                    }}
                                >
                                    {
                                        userFaceUrl !== ''
                                            ? <img src={userFaceUrl} className={classes.video} alt="IMAGEM"/>
                                            : (
                                                <Typography
                                                    variant="subtitle1"
                                                    className={classes.accessImageAlt}
                                                >
                                                    SEM IMAGEM CADASTRADA
                                                </Typography>
                                            )
                                    }
                                </Grid>
                            </Grid>
                            <Grid container alignItems='center' justify='center'>
                                <Typography
                                    variant="subtitle1"
                                    className={classes.accessImageAlt}
                                >
                                    NO ACESSO
                                </Typography>
                                <Grid
                                    item
                                    xs={12}
                                    style={{
                                        background: grey[500],
                                        height: "300px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: 15
                                    }}
                                >
                                    {
                                        (notification_web?.web_notification?.access_log && mediaUrl) ? (
                                            <AccessMedia log={notification_web?.web_notification?.access_log}
                                                         url={mediaUrl}/>
                                        ) : (
                                            <Typography
                                                variant="subtitle1"
                                                className={classes.accessImageAlt}
                                            >
                                                NÃO POSSÍVEL RECUPERAR A IMAGEM/VIDEO DO ACESSO
                                            </Typography>
                                        )

                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={8}>
                        <DialogTitle id="scroll-dialog-title">
                            {notification_web?.web_notification?.notification?.name}
                        </DialogTitle>
                        <DialogContent dividers='paper'>
                            <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
                                <strong>Descrição:</strong>
                                {notification_web?.web_notification?.description}
                            </DialogContentText>
                            <DialogContentText id="scroll-dialog-description" tabIndex={-1}>
                                <strong>Mensagem:</strong> {notification_web?.web_notification?.message}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => {
                                setMediaUrl('');
                                setUserFaceUrl('');
                                handleView()
                            }
                            } autoFocus>Visualizado</Button>
                        </DialogActions>
                    </Grid>
                </Grid>
            </Dialog>
            {!!message.open && (
                <Alert
                    open={message.open}
                    autoHideDuration={6000}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    severity={message.variant}
                    onClose={closeMessage}
                >
                    {message.text}
                </Alert>
            )}
        </div>

    );
}

const useStyles = makeStyles((theme) => ({
    accessImageAlt: {
        fontWeight: 700,
        color: grey[900],
    },
    video: {
        maxHeight: '100%',
        height: '100%',
        maxWidth: '100%',
        display: 'block',
        margin: 'auto',
    },
}));
